import React, { useEffect, useState } from "react";
import Image from "next/image";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from "@material-tailwind/react";
import { AiFillQuestionCircle } from "react-icons/ai";
import { MdQuestionAnswer } from "react-icons/md";
import { getLocals } from "../../../getLocal";
import { hostNameFunction } from "../../../utils/host-function";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

export default function FAQ({ data }) {
  const [localizedStrings, setLocalizedStrings] = useState();

  useEffect(() => {
    const fetchLocalizedStrings = async () => {
      const lang = hostNameFunction() || "en";
      const strings = await getLocals(lang);
      setLocalizedStrings(strings);
    };

    fetchLocalizedStrings();
  }, []);
  const [open, setOpen] = React.useState(0);

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  return (
    <>
      <div className="pb-10">
        <div className="flex items-center gap-2 pb-4">
          <div>
            <Image
              src="/assets/img/faq.svg"
              className="md:w-8 md:h-8 w-8"
              height={500}
              width={500}
              alt="image"
            />
          </div>
          <div>
            <p className="text-xl">
              <b>
                {localizedStrings && localizedStrings.Index.BusinessPage.FAQs}:
              </b>
            </p>
          </div>
        </div>

        {data.map((item, index) => (
          <div className="border-solid rounded border-2 mb-4 p-2" key={index}>
            <Accordion open={open == index} icon={<Icon id={1} open={open} />}>
              <AccordionHeader
                className="flex gap-2 items-center py-2 cursor-pointer transition-colors duration-300 hover:bg-gray-100"
                onClick={() => handleOpen(index)}
              >
                <div className="flex items-center gap-1">
                  <AiFillQuestionCircle className="h-7 w-7 md:h-5 md:w-5" />
                  <p className="text-base">
                    <b>{item.ques}</b>
                  </p>
                </div>
              </AccordionHeader>
              <AccordionBody className="flex gap-2 py-2">
                <div className="flex items-center gap-1">
                  <MdQuestionAnswer className="h-7 w-7 md:h-5 md:w-5" />
                  <p className="text-base">{item.ans}</p>
                </div>
              </AccordionBody>
            </Accordion>
          </div>
        ))}
      </div>
    </>
  );
}
